(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ee-awareness-page"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('[data-ee-awareness]').forEach(function(root){
      var progress=root.querySelector('[data-ee-awareness-progress]');
      var updateProgress=function(){var rect=root.getBoundingClientRect();var distance=Math.max(1,root.offsetHeight-window.innerHeight);var value=Math.min(1,Math.max(0,-rect.top/distance));if(progress)progress.style.transform='scaleX('+value+')'};
      window.addEventListener('scroll',updateProgress,{passive:true});updateProgress();
      if('IntersectionObserver' in window){var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}})},{threshold:.12});root.querySelectorAll('.ee-awareness__reveal').forEach(function(item){observer.observe(item)})}else{root.querySelectorAll('.ee-awareness__reveal').forEach(function(item){item.classList.add('is-visible')})}
      var buttons=root.querySelectorAll('[data-ee-rx-button]');var panels=root.querySelectorAll('[data-ee-rx-panel]');buttons.forEach(function(button){button.addEventListener('click',function(){var key=button.getAttribute('data-ee-rx-button');buttons.forEach(function(item){item.setAttribute('aria-selected','false')});panels.forEach(function(panel){panel.hidden=panel.getAttribute('data-ee-rx-panel')!==key});button.setAttribute('aria-selected','true')})});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ee-carousel]').forEach(function (carousel) {
    if (carousel.dataset.bound === 'true') return;
    carousel.dataset.bound = 'true';
    var track = carousel.querySelector('[data-carousel-track]');
    var progress = carousel.querySelector('[data-carousel-progress]');
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    if (!track) return;
    function step() {
      var slide = track.querySelector('.ee-carousel__slide');
      return slide ? slide.getBoundingClientRect().width + 14 : 300;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    function paint() {
      var max = track.scrollWidth - track.clientWidth;
      if (!progress || max <= 0) return;
      var frac = Math.min(Math.max(track.scrollLeft / max, 0), 1);
      var w = Math.max(track.clientWidth / track.scrollWidth, 0.08);
      progress.style.width = (w * 100) + '%';
      progress.style.transform = 'translateX(' + (frac * (100 / w - 100)) + '%)';
    }
    track.addEventListener('scroll', function () { requestAnimationFrame(paint); }, { passive: true });
    window.addEventListener('resize', paint);
    paint();
    if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      var down = false, startX = 0, startScroll = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft;
        track.style.scrollSnapType = 'none';
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 6) { moved = true; track.setPointerCapture(e.pointerId); }
        track.scrollLeft = startScroll - dx;
      });
      function end() {
        if (!down) return;
        down = false;
        setTimeout(function () { track.style.scrollSnapType = ''; }, 250);
      }
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
      track.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-drop-timer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ee-drop]').forEach(function (drop) {
    if (drop.dataset.bound === 'true') return;
    drop.dataset.bound = 'true';
    var raw = (drop.dataset.end || '').trim();
    if (!raw) return;
    var iso = raw.replace(' ', 'T');
    if (iso.length === 16) iso += ':00';
    var end = new Date(iso + '+05:30').getTime();
    if (isNaN(end)) return;
    var d = drop.querySelector('[data-drop-d]');
    var h = drop.querySelector('[data-drop-h]');
    var m = drop.querySelector('[data-drop-m]');
    var s = drop.querySelector('[data-drop-s]');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var left = end - Date.now();
      if (left <= 0) { drop.classList.remove('is-live'); clearInterval(timer); return; }
      drop.classList.add('is-live');
      var sec = Math.floor(left / 1000);
      if (d) d.textContent = pad(Math.floor(sec / 86400));
      if (h) h.textContent = pad(Math.floor(sec % 86400 / 3600));
      if (m) m.textContent = pad(Math.floor(sec % 3600 / 60));
      if (s) s.textContent = pad(sec % 60);
    }
    var timer = setInterval(tick, 1000);
    tick();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-heroslider]').forEach(function (slider) {
    if (slider.dataset.bound === 'true') return;
    slider.dataset.bound = 'true';
    var track = slider.querySelector('[data-heroslider-track]');
    if (!track) return;
    var slides = track.children;
    if (slides.length < 2) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var dots = slider.querySelector('[data-heroslider-dots]');
    var count = slider.querySelector('[data-heroslider-count]');
    var prev = slider.querySelector('[data-heroslider-prev]');
    var next = slider.querySelector('[data-heroslider-next]');
    var index = 0;
    function paint(i) {
      index = i;
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      if (dots) Array.prototype.forEach.call(dots.children, function (d, j) { d.classList.toggle('on', j === i); });
    }
    function goTo(i, instant) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: instant || reduced ? 'auto' : 'smooth' });
      paint(i);
    }
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var w = track.clientWidth;
        if (!w) return;
        paint(Math.max(0, Math.min(Math.round(track.scrollLeft / w), slides.length - 1)));
      }, 90);
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { stop(); goTo(index - 1); start(); });
    if (next) next.addEventListener('click', function () { stop(); goTo(index + 1); start(); });
    var timer = null;
    var interval = (parseInt(slider.dataset.interval, 10) || 5) * 1000;
    function start() {
      if (reduced || slider.dataset.autoplay !== 'true' || timer) return;
      timer = setInterval(function () { goTo(index + 1); }, interval);
    }
    function stop() {
      clearInterval(timer);
      timer = null;
    }
    slider.addEventListener('pointerenter', stop);
    slider.addEventListener('pointerleave', start);
    track.addEventListener('pointerdown', stop);
    track.addEventListener('touchstart', stop, { passive: true });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    start();
    if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      var down = false, startX = 0, startScroll = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft;
        track.style.scrollSnapType = 'none';
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 6) { moved = true; track.setPointerCapture(e.pointerId); }
        track.scrollLeft = startScroll - dx;
      });
      function end() {
        if (!down) return;
        down = false;
        var w = track.clientWidth;
        goTo(Math.round(track.scrollLeft / w));
        setTimeout(function () { track.style.scrollSnapType = ''; }, 350);
        start();
      }
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
      track.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-instrument-home"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root=document.querySelector('[data-ei-home]');if(!root)return;
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hero=root.querySelector('[data-ei-hero]'),heroSlides=hero?Array.from(hero.querySelectorAll('[data-ei-hero-slide]')):[],heroDots=hero?Array.from(hero.querySelectorAll('[data-ei-hero-dot]')):[];
    if(hero&&heroSlides.length){
      var heroIndex=0,heroTimer=null,heroTouchX=0,heroModel=hero.querySelector('[data-ei-hero-model]'),heroShape=hero.querySelector('[data-ei-hero-shape]'),heroSize=hero.querySelector('[data-ei-hero-size]'),heroCurrent=hero.querySelector('[data-ei-hero-current]'),heroTotal=hero.querySelector('[data-ei-hero-total]'),heroAction=hero.querySelector('[data-ei-hero-action]');
      if(heroTotal)heroTotal.textContent=String(heroSlides.length).padStart(2,'0');
      function heroShow(next){
        next=(next+heroSlides.length)%heroSlides.length;
        heroSlides.forEach(function(slide,index){slide.classList.toggle('is-exiting',index===heroIndex&&index!==next);slide.classList.toggle('is-active',index===next);slide.setAttribute('aria-hidden',index===next?'false':'true');slide.tabIndex=index===next?0:-1});
        window.setTimeout(function(){heroSlides.forEach(function(slide,index){if(index!==next)slide.classList.remove('is-exiting')})},900);
        heroDots.forEach(function(dot,index){dot.classList.toggle('is-active',index===next);dot.classList.toggle('is-past',index<next)});
        heroIndex=next;var active=heroSlides[heroIndex];
        if(heroModel)heroModel.textContent=active.getAttribute('data-model')||'';
        if(heroShape)heroShape.textContent=active.getAttribute('data-shape')||'';
        if(heroSize)heroSize.textContent=active.getAttribute('data-size')||'';
        if(heroCurrent)heroCurrent.textContent=String(heroIndex+1).padStart(2,'0');
        if(heroAction)heroAction.href=active.href;
      }
      function heroStop(){if(heroTimer){window.clearInterval(heroTimer);heroTimer=null}hero.classList.add('is-paused')}
      function heroStart(){hero.classList.remove('is-paused');if(reduce||heroSlides.length<2)return;if(heroTimer)window.clearInterval(heroTimer);heroTimer=window.setInterval(function(){heroShow(heroIndex+1)},5200)}
      var heroPrev=hero.querySelector('[data-ei-hero-prev]'),heroNext=hero.querySelector('[data-ei-hero-next]');
      if(heroPrev)heroPrev.addEventListener('click',function(){heroShow(heroIndex-1);heroStart()});
      if(heroNext)heroNext.addEventListener('click',function(){heroShow(heroIndex+1);heroStart()});
      heroDots.forEach(function(dot){dot.addEventListener('click',function(){heroShow(Number(dot.getAttribute('data-ei-hero-dot')));heroStart()})});
      hero.addEventListener('mouseenter',heroStop);hero.addEventListener('mouseleave',heroStart);hero.addEventListener('focusin',heroStop);hero.addEventListener('focusout',function(event){if(!hero.contains(event.relatedTarget))heroStart()});
      hero.addEventListener('pointerdown',function(event){if(event.pointerType==='touch')heroTouchX=event.clientX},{passive:true});
      hero.addEventListener('pointerup',function(event){if(event.pointerType!=='touch')return;var delta=event.clientX-heroTouchX;if(Math.abs(delta)>48){heroShow(heroIndex+(delta<0?1:-1));heroStart()}},{passive:true});
      document.addEventListener('visibilitychange',function(){if(document.hidden)heroStop();else heroStart()});heroShow(0);heroStart();
    }
    var reveals=root.querySelectorAll('.ei-reveal');
    if('IntersectionObserver' in window&&!reduce){var revealObserver=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');revealObserver.unobserve(entry.target)}})},{threshold:.16});reveals.forEach(function(el){revealObserver.observe(el)})}else{reveals.forEach(function(el){el.classList.add('is-visible')})}

    var lens=root.querySelector('[data-ei-lens]'),lensMedia=root.querySelector('[data-ei-lens-media]'),lensRing=root.querySelector('[data-ei-lens-ring]');
    var ethos=root.querySelector('[data-ei-ethos]'),ethosWords=root.querySelectorAll('[data-ei-ethos-text] span');
    function onScroll(){
      if(lens&&lensMedia&&!reduce){var lr=lens.getBoundingClientRect(),travel=Math.max(1,lens.offsetHeight-window.innerHeight),lp=Math.max(0,Math.min(1,-lr.top/travel)),eased=lp<.5?2*lp*lp:1-Math.pow(-2*lp+2,2)/2,radius=14+eased*96;lensMedia.style.clipPath='circle('+radius+'% at 50% 42%)';lens.style.setProperty('--ei-lens-progress',String(eased));if(lensRing)lensRing.style.opacity=String(Math.max(0,1-Math.max(0,lp-.08)/.3))}
      if(ethos){var er=ethos.getBoundingClientRect(),ep=Math.max(0,Math.min(1,-er.top/(er.height-window.innerHeight)));var lit=Math.ceil(ep*ethosWords.length*1.08);ethosWords.forEach(function(word,index){word.classList.toggle('is-lit',index<lit)})}
    }
    var scrollTicking=false;
    function scheduleScroll(){if(scrollTicking)return;scrollTicking=true;requestAnimationFrame(function(){onScroll();scrollTicking=false})}
    window.addEventListener('scroll',scheduleScroll,{passive:true});onScroll();

    var rail=root.querySelector('[data-ei-drag]');if(rail){var down=false,startX=0,startScroll=0;rail.addEventListener('pointerdown',function(e){down=true;startX=e.clientX;startScroll=rail.scrollLeft;rail.classList.add('is-dragging');rail.setPointerCapture(e.pointerId)});rail.addEventListener('pointermove',function(e){if(down)rail.scrollLeft=startScroll-(e.clientX-startX)});function stop(){down=false;rail.classList.remove('is-dragging')}rail.addEventListener('pointerup',stop);rail.addEventListener('pointercancel',stop)}

    var tintStage=root.querySelector('[data-ei-tint-stage]'),tintImage=tintStage?tintStage.querySelector('img'):null;
    root.querySelectorAll('[data-ei-tint-button]').forEach(function(button){button.addEventListener('click',function(){root.querySelectorAll('[data-ei-tint-button]').forEach(function(item){item.setAttribute('aria-selected','false')});button.setAttribute('aria-selected','true');if(!tintStage)return;tintStage.style.setProperty('--tint',button.getAttribute('data-tint'));var variantUrl=button.getAttribute('data-url');if(variantUrl)tintStage.setAttribute('href',variantUrl);var nextImage=button.getAttribute('data-image');if(!tintImage||!nextImage)return;tintImage.classList.add('is-changing');var preload=new Image();preload.onload=function(){tintImage.removeAttribute('srcset');tintImage.removeAttribute('sizes');tintImage.src=nextImage;tintImage.alt=button.getAttribute('data-alt')||'';requestAnimationFrame(function(){tintImage.classList.remove('is-changing')})};preload.src=nextImage})});

    function bindTakeover(scopeSelector,rowSelector,previewSelector,activeClass){var scope=root.querySelector(scopeSelector);if(!scope)return;var rows=scope.querySelectorAll(rowSelector),previews=scope.querySelectorAll(previewSelector);function activate(id,row){scope.classList.add(activeClass);rows.forEach(function(item){item.classList.toggle('is-active',item===row)});previews.forEach(function(item){item.classList.toggle('is-active',item.getAttribute(previewSelector.indexOf('shape')>-1?'data-ei-shape-preview':'data-ei-collection-preview')===id)})}function clear(){scope.classList.remove(activeClass);rows.forEach(function(item){item.classList.remove('is-active')});previews.forEach(function(item){item.classList.remove('is-active')})}rows.forEach(function(row){var attr=row.hasAttribute('data-ei-shape-row')?'data-ei-shape-row':'data-ei-collection-row';row.addEventListener('mouseenter',function(){activate(row.getAttribute(attr),row)});row.addEventListener('focus',function(){activate(row.getAttribute(attr),row)})});scope.addEventListener('mouseleave',clear);scope.addEventListener('focusout',function(e){if(!scope.contains(e.relatedTarget))clear()})}
    bindTakeover('[data-ei-collections]','[data-ei-collection-row]','[data-ei-collection-preview]','has-active');bindTakeover('[data-ei-shapes]','[data-ei-shape-row]','[data-ei-shape-preview]','has-active');

    var field=root.querySelector('[data-ei-field]');
    if(field){
      var fieldGrid=field.querySelector('[data-ei-field-grid]'),fieldTabs=field.querySelectorAll('[data-ei-field-tab]'),fieldSeries=field.querySelector('[data-ei-field-series]'),fieldSentinel=field.querySelector('[data-ei-field-sentinel]'),fieldStatus=field.querySelector('[data-ei-field-status]'),fieldLoad=field.querySelector('[data-ei-field-load]'),fieldEnd=field.querySelector('[data-ei-field-end]');
      var fieldLimit=Number(field.getAttribute('data-limit'))||12,fieldPage=1,fieldLoading=false,fieldDone=false,fieldRequest=0,fieldUrl=fieldTabs[0]?fieldTabs[0].getAttribute('data-url'):'';
      var fieldSeen=new Set(),fieldMoney=new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0});
      fieldGrid.querySelectorAll('[data-product-handle]').forEach(function(card){fieldSeen.add(card.getAttribute('data-product-handle'))});
      function fieldEsc(value){return String(value==null?'':value).replace(/[&<>"']/g,function(char){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[char]})}
      function fieldImage(value){if(!value)return '';return typeof value==='string'?value:(value.src||'')}
      function fieldWidth(src,width){if(!src)return '';return src+(src.indexOf('?')>-1?'&':'?')+'width='+width}
      function fieldPrice(value){var number=Number(value);return Number.isFinite(number)?fieldMoney.format(number):fieldEsc(value)}
      function fieldCard(product){
        var variants=product.variants||[],active=variants.find(function(variant){return variant.available!==false})||variants[0];if(!active)return '';
        var images=product.images||[],mainImage=fieldImage(active.featured_image)||fieldImage(product.image)||fieldImage(images[0]),alternate=fieldImage(images[1]);
        var productUrl='/products/'+encodeURIComponent(product.handle),variantUrl=productUrl+'?variant='+active.id,price=fieldPrice(active.price),compare=Number(active.compare_at_price)>Number(active.price)?'<s>'+fieldPrice(active.compare_at_price)+'</s>':'';
        var finishes=variants.slice(0,4).map(function(variant){var image=fieldImage(variant.featured_image)||mainImage,url=productUrl+'?variant='+variant.id;return '<button class="product-card__finish-option" type="button" data-card-finish data-variant-id="'+fieldEsc(variant.id)+'" data-title="'+fieldEsc(variant.title)+'" data-image="'+fieldEsc(fieldWidth(image,900))+'" data-url="'+fieldEsc(url)+'" data-alt="'+fieldEsc(product.title+' / '+variant.title)+'" data-price="'+fieldEsc(fieldPrice(variant.price))+'" aria-label="'+fieldEsc(variant.title)+' / '+fieldEsc(product.title)+'" aria-pressed="'+(variant.id===active.id?'true':'false')+'"><img src="'+fieldEsc(fieldWidth(image,180))+'" width="180" height="140" loading="lazy" decoding="async" alt=""></button>'}).join('');
        var finishCount=Math.min(variants.length,5),more=variants.length>4?'<a class="product-card__finish-more micro" href="'+fieldEsc(productUrl)+'">+'+(variants.length-4)+' '+fieldEsc(field.getAttribute('data-more-text'))+'</a>':'';
        var slides=variants.map(function(variant){var image=fieldImage(variant.featured_image)||mainImage,url=productUrl+'?variant='+variant.id;return '<span class="ee-cardswipe__slide" data-variant-id="'+fieldEsc(variant.id)+'" data-title="'+fieldEsc(variant.title)+'" data-price="'+fieldEsc(fieldPrice(variant.price))+'" data-url="'+fieldEsc(url)+'" data-active="'+(variant.id===active.id?'true':'false')+'"><img src="'+fieldEsc(fieldWidth(image,900))+'" width="900" height="700" loading="lazy" decoding="async" alt="'+fieldEsc(product.title+' / '+variant.title)+'"></span>'}).join('');
        var available=active.available!==false,buttonText=available?field.getAttribute('data-add-text'):field.getAttribute('data-sold-text');
        return '<article class="product-card" data-product-card data-product-handle="'+fieldEsc(product.handle)+'"><a class="product-card__link" href="'+fieldEsc(variantUrl)+'" data-card-link><div class="product-card__image ee-cardswipe" data-cardswipe><div class="ee-cardswipe__track" data-cardswipe-track>'+slides+'</div></div><div class="product-card__body"><div><h3>'+fieldEsc(product.title)+'</h3><p class="micro">'+fieldEsc(product.vendor||product.product_type||'Eyewear Essentials')+'</p><p class="micro product-card__finish" data-card-finish-label>'+fieldEsc(active.title||'')+'</p></div><span class="product-card__price-wrap">'+compare+'<span class="product-card__price" data-card-price>'+price+'</span></span></div></a>'+(variants.length>1?'<div class="product-card__finishes" style="--finish-count:'+finishCount+'" aria-label="Available finishes">'+finishes+more+'</div>':'')+'<form class="product-card__quick-form" action="/cart/add" method="post" data-card-quick-form><input type="hidden" name="id" value="'+fieldEsc(active.id)+'" data-card-variant-input><input type="hidden" name="quantity" value="1"><button class="product-card__quick-add" type="submit" data-add-button '+(available?'':'disabled')+'><span>'+fieldEsc(buttonText)+'</span><span aria-hidden="true">+</span></button></form></article>';
      }
      function fieldComplete(){fieldDone=true;fieldSentinel.classList.add('is-complete');fieldStatus.textContent=field.getAttribute('data-ready-text');fieldEnd.setAttribute('href',fieldUrl)}
      function fieldFetch(reset){
        if(fieldLoading||!fieldUrl||fieldDone&&!reset)return;
        fieldLoading=true;fieldDone=false;fieldSentinel.classList.remove('is-complete');fieldLoad.disabled=true;fieldStatus.textContent=field.getAttribute('data-loading-text');fieldGrid.classList.add('is-loading');
        if(reset){fieldPage=1;fieldSeen.clear();fieldGrid.innerHTML=''}
        var request=++fieldRequest,url=fieldUrl.replace(/\/$/,'')+'/products.json?limit='+fieldLimit+'&page='+fieldPage;
        fetch(url,{headers:{Accept:'application/json'}}).then(function(response){if(!response.ok)throw new Error('Catalogue unavailable');return response.json()}).then(function(payload){
          if(request!==fieldRequest)return;var products=payload.products||[],html='';products.forEach(function(product){if(product.handle==='lens-add-ons'||fieldSeen.has(product.handle))return;fieldSeen.add(product.handle);html+=fieldCard(product)});if(html){fieldGrid.insertAdjacentHTML('beforeend',html);fieldGrid.dispatchEvent(new CustomEvent('shopify:section:load',{bubbles:true}))}fieldPage+=1;if(products.length<fieldLimit)fieldComplete();else fieldStatus.textContent=field.getAttribute('data-ready-text')
        }).catch(function(){if(request!==fieldRequest)return;fieldStatus.textContent=field.getAttribute('data-error-text')}).finally(function(){if(request!==fieldRequest)return;fieldLoading=false;fieldLoad.disabled=false;fieldGrid.classList.remove('is-loading')})
      }
      fieldTabs.forEach(function(tab){tab.addEventListener('click',function(){if(tab.getAttribute('aria-selected')==='true'&&fieldGrid.children.length)return;fieldTabs.forEach(function(item){item.setAttribute('aria-selected',item===tab?'true':'false')});fieldUrl=tab.getAttribute('data-url');fieldSeries.textContent=tab.getAttribute('data-series');fieldEnd.setAttribute('href',fieldUrl);fieldRequest+=1;fieldLoading=false;fieldFetch(true)})});
      fieldLoad.addEventListener('click',function(){fieldFetch(false)});
      field.addEventListener('click',function(event){var finish=event.target.closest('[data-card-finish]');if(!finish||!field.contains(finish))return;event.preventDefault();var card=finish.closest('[data-product-card]'),track=card.querySelector('[data-cardswipe-track]'),image=card.querySelector('.product-card__image img'),link=card.querySelector('[data-card-link]'),label=card.querySelector('[data-card-finish-label]'),price=card.querySelector('[data-card-price]'),input=card.querySelector('[data-card-variant-input]');if(!track&&image&&finish.dataset.image){image.removeAttribute('srcset');image.removeAttribute('sizes');image.src=finish.dataset.image;image.alt=finish.dataset.alt||''}if(link&&finish.dataset.url)link.href=finish.dataset.url;if(label)label.textContent=finish.dataset.title||'';if(price)price.textContent=finish.dataset.price||'';if(input&&finish.dataset.variantId)input.value=finish.dataset.variantId;card.querySelectorAll('[data-card-finish]').forEach(function(item){item.setAttribute('aria-pressed',item===finish?'true':'false')})});
      field.addEventListener('submit',function(event){if(!event.target.closest('[data-card-quick-form]'))return;setTimeout(function(){fetch('/cart.js').then(function(response){return response.json()}).then(function(cart){document.querySelectorAll('.ee-nav__count').forEach(function(count){count.textContent='('+cart.item_count+')'})})},1100)});
      if('IntersectionObserver' in window){var fieldObserver=new IntersectionObserver(function(entries){if(entries[0].isIntersecting)fieldFetch(false)},{rootMargin:'800px 0px'});fieldObserver.observe(fieldSentinel)}
    }

    var craft=root.querySelector('[data-ei-craft]'),counted=false;if(craft&&'IntersectionObserver' in window){var countObserver=new IntersectionObserver(function(entries){if(entries[0].isIntersecting&&!counted){counted=true;root.querySelectorAll('[data-ei-count]').forEach(function(el){var target=Number(el.getAttribute('data-ei-count')),start=performance.now();function tick(now){var p=Math.min(1,(now-start)/1200),value=Math.round(target*(1-Math.pow(1-p,3)));el.textContent=String(value).padStart(target>99?3:2,'0');if(p<1)requestAnimationFrame(tick)}requestAnimationFrame(tick)});countObserver.disconnect()}},{threshold:.35});countObserver.observe(craft)}

    var notes=root.querySelectorAll('[data-ei-note]'),noteButtons=root.querySelectorAll('[data-ei-note-button]');noteButtons.forEach(function(button){button.addEventListener('click',function(){var index=Number(button.getAttribute('data-ei-note-button'));notes.forEach(function(note,i){note.classList.toggle('is-active',i===index)});noteButtons.forEach(function(item,i){item.classList.toggle('is-active',i===index)})})});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-lens-portal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-ee-portal]').forEach(function (portal) {
      if (portal.dataset.bound === 'true') return;
      portal.dataset.bound = 'true';
      var lens = portal.querySelector('[data-portal-lens]');
      var text = portal.querySelector('[data-portal-text]');
      var ring = portal.querySelector('[data-portal-ring]');
      if (!lens) return;
      var ticking = false;
      function paint() {
        var rect = portal.getBoundingClientRect();
        var total = rect.height - window.innerHeight;
        var progress = total > 0 ? Math.min(Math.max(-rect.top / total, 0), 1) : 1;
        var eased = progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
        var radius = 6 + eased * 130;
        lens.style.clipPath = 'circle(' + radius.toFixed(2) + '% at 50% 55%)';
        if (text) {
          text.style.opacity = String(Math.max(0, 1 - progress * 1.6));
          text.style.transform = 'scale(' + (1 - progress * 0.08).toFixed(3) + ')';
        }
        if (ring) {
          var d = Math.max(0, Math.min(radius, 60)) * 2;
          ring.style.width = d + 'vmin';
          ring.style.height = d + 'vmin';
          ring.style.opacity = String(progress > 0.45 ? Math.max(0, 1 - (progress - 0.45) * 4) : 0.9);
        }
        ticking = false;
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { requestAnimationFrame(paint); ticking = true; }
      }, { passive: true });
      window.addEventListener('resize', paint);
      paint();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-luminous-home"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('[data-lm-home]');
  if(!root)return;
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var reveal=root.querySelectorAll('[data-lm-reveal]');
  if(reduced||!('IntersectionObserver' in window)){reveal.forEach(function(el){el.classList.add('lm-in')})}else{
    var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('lm-in');observer.unobserve(entry.target)}})},{threshold:.12,rootMargin:'0px 0px -6% 0px'});
    reveal.forEach(function(el){observer.observe(el)});
  }
  var visual=root.querySelector('[data-lm-visual]');
  if(visual&&!reduced&&window.matchMedia('(pointer:fine)').matches){visual.addEventListener('pointermove',function(event){var rect=visual.getBoundingClientRect();var x=(event.clientX-rect.left)/rect.width;var y=(event.clientY-rect.top)/rect.height;visual.style.setProperty('--mx',(x*100)+'%');visual.style.setProperty('--my',(y*100)+'%');visual.style.setProperty('--tx',((x-.5)*18)+'px');visual.style.setProperty('--ty',((y-.5)*18)+'px');visual.style.setProperty('--ry',((x-.5)*8)+'deg');visual.style.setProperty('--rx',((.5-y)*8)+'deg')});visual.addEventListener('pointerleave',function(){['--tx','--ty','--ry','--rx'].forEach(function(name){visual.style.removeProperty(name)})})}
  var collectionsRoot=root.dataset.collectionsRoot;
  var answers={round:{text:'Angular rectangles and wayfarers add definition.',href:collectionsRoot+'/rectangle'},square:{text:'Rounder and aviator silhouettes soften strong angles.',href:collectionsRoot+'/aviator'},oval:{text:'Most silhouettes work—start with bold square frames.',href:collectionsRoot+'/square'}};
  root.querySelectorAll('[data-lm-fit]').forEach(function(button){button.addEventListener('click',function(){var answer=answers[button.dataset.lmFit];root.querySelectorAll('[data-lm-fit]').forEach(function(item){item.setAttribute('aria-selected',item===button?'true':'false')});root.querySelector('[data-lm-answer]').textContent=answer.text;root.querySelector('[data-lm-answer-link]').href=answer.href})});
  if(!reduced&&window.matchMedia('(pointer:fine)').matches){root.querySelectorAll('[data-lm-magnetic]').forEach(function(button){button.addEventListener('pointermove',function(event){var rect=button.getBoundingClientRect();button.style.transform='translate('+((event.clientX-rect.left-rect.width/2)*.08)+'px,'+((event.clientY-rect.top-rect.height/2)*.12)+'px)'});button.addEventListener('pointerleave',function(){button.style.transform=''})})}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-motion"]) return;
  try {
    
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  if (!reduced) {
    var bar = document.createElement('div');
    bar.className = 'ee-progress';
    document.body.appendChild(bar);
    var ticking = false;
    var paint = function () {
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      var p = max > 0 ? window.scrollY / max : 0;
      bar.style.transform = 'scaleX(' + Math.min(Math.max(p, 0), 1) + ')';
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(paint); ticking = true; }
    }, { passive: true });
    paint();
  }

  var toast, toastTimer;
  function showToast(html, isError) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ee-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.classList.toggle('ee-toast--error', !!isError);
    toast.innerHTML = html;
    requestAnimationFrame(function () { toast.classList.add('is-active'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-active'); }, 3400);
  }

  /* AJAX add-to-cart (v8: supports paired lens add-on) */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    event.preventDefault();
    var button = form.querySelector('[data-add-button]') || form.querySelector('[type="submit"]');
    var label = button ? button.querySelector('span') : null;
    var original = label ? label.textContent : '';
    if (button) { button.disabled = true; if (label) label.innerHTML = '<span class="ee-spinner"></span>'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
        return r.json();
      })
      .then(function () {
        var lens = form.querySelector('input[name="lens_variant"]:checked');
        if (lens && lens.value) {
          var q = parseInt((form.querySelector('input[name="quantity"]') || {}).value, 10) || 1;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(lens.value, 10), quantity: q, properties: { '_Paired with': lens.dataset.frame || 'frame' } }] })
          }).then(function (r2) {
            if (!r2.ok) throw new Error('Lenses could not be added — please retry');
          });
        }
      })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count,.ee-nav__count').forEach(function (el) {
          el.textContent = el.classList.contains('ee-nav__count') ? '(' + cart.item_count + ')' : cart.item_count;
          el.classList.remove('ee-pop');
          void el.offsetWidth;
          el.classList.add('ee-pop');
        });
        document.dispatchEvent(new CustomEvent('ee:cart-updated', { detail: { cart: cart } }));
        if (button) { button.classList.add('ee-added'); if (label) label.textContent = 'Added ✓'; }
        showToast('Added to cart <a href="/cart">View cart ↗</a>');
        setTimeout(function () {
          if (button) { button.disabled = false; button.classList.remove('ee-added'); if (label) label.textContent = original; }
        }, 2200);
      })
      .catch(function (err) {
        if (button) { button.disabled = false; if (label) label.textContent = original; }
        showToast(err.message || 'Could not add to cart', true);
      });
  });

  document.addEventListener('change', function (event) {
    if (!event.target.closest('[data-variant-selector]')) return;
    var price = document.querySelector('[data-product-price]');
    if (!price) return;
    price.classList.remove('ee-price-flip');
    void price.offsetWidth;
    price.classList.add('ee-price-flip');
  });

  var toggle = document.querySelector('[data-menu-toggle]');
  var drawer = document.querySelector('[data-mobile-drawer]');
  function setDrawer(open) {
    if (!drawer || !toggle) return;
    drawer.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('ee-locked', open);
  }
  if (toggle && drawer) {
    toggle.addEventListener('click', function () { setDrawer(!drawer.classList.contains('is-open')); });
    drawer.addEventListener('click', function (event) {
      if (event.target.closest('a') || event.target.closest('[data-menu-close]')) setDrawer(false);
    });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') setDrawer(false); });
  }

  if (!reduced && finePointer) {
    document.querySelectorAll('.button, .hero-cta').forEach(function (el) {
      el.addEventListener('mousemove', function (event) {
        var rect = el.getBoundingClientRect();
        var x = (event.clientX - rect.left - rect.width / 2) / rect.width;
        var y = (event.clientY - rect.top - rect.height / 2) / rect.height;
        el.style.translate = (x * 6).toFixed(1) + 'px ' + (y * 4).toFixed(1) + 'px';
      });
      el.addEventListener('mouseleave', function () { el.style.translate = '0px 0px'; });
    });
  }

  function watchSnap(track, cb) {
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var w = track.clientWidth;
        if (!w) return;
        cb(Math.round(track.scrollLeft / w));
      }, 90);
    }, { passive: true });
  }
  function enableDrag(track) {
    if (!finePointer) return;
    var down = false, startX = 0, startScroll = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft;
      track.style.scrollSnapType = 'none';
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 6) { moved = true; track.setPointerCapture(e.pointerId); }
      track.scrollLeft = startScroll - dx;
    });
    function end() {
      if (!down) return;
      down = false;
      var w = track.clientWidth;
      var target = Math.round(track.scrollLeft / w) * w;
      track.scrollTo({ left: target, behavior: 'smooth' });
      setTimeout(function () { track.style.scrollSnapType = ''; }, 350);
    }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  function initCardSwipe(swipe) {
    if (swipe.dataset.swipeBound === 'true') return;
    swipe.dataset.swipeBound = 'true';
    var track = swipe.querySelector('[data-cardswipe-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;
    var card = swipe.closest('[data-product-card]');
    var dots = document.createElement('div');
    dots.className = 'ee-cardswipe__dots';
    slides.forEach(function () { dots.appendChild(document.createElement('i')); });
    swipe.appendChild(dots);
    var hint = document.createElement('span');
    hint.className = 'ee-cardswipe__hint';
    hint.textContent = 'Swipe ↔';
    swipe.appendChild(hint);
    function setDot(i) {
      Array.prototype.forEach.call(dots.children, function (d, j) { d.classList.toggle('on', j === i); });
    }
    var startIdx = 0;
    slides.forEach(function (s, j) { if (s.dataset.active === 'true') startIdx = j; });
    setDot(startIdx);
    if (startIdx > 0) {
      requestAnimationFrame(function () { track.scrollLeft = startIdx * track.clientWidth; });
    }
    function syncSlide(i) {
      i = Math.max(0, Math.min(i, slides.length - 1));
      setDot(i);
      var slide = slides[i];
      if (!card || !slide) return;
      var label = card.querySelector('[data-card-finish-label]');
      var price = card.querySelector('[data-card-price]');
      var link = card.querySelector('[data-card-link]');
      var input = card.querySelector('[data-card-variant-input]');
      if (label && slide.dataset.title) label.textContent = slide.dataset.title;
      if (price && slide.dataset.price) price.textContent = slide.dataset.price;
      if (link && slide.dataset.url) link.href = slide.dataset.url;
      if (input && slide.dataset.variantId) input.value = slide.dataset.variantId;
      card.querySelectorAll('[data-card-finish]').forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.dataset.url === slide.dataset.url ? 'true' : 'false');
      });
    }
    watchSnap(track, syncSlide);
    var touchStart = null;
    track.addEventListener('touchstart', function (event) {
      if (!event.touches || event.touches.length !== 1) return;
      var touch = event.touches[0];
      touchStart = { x: touch.clientX, y: touch.clientY, index: Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) };
    }, { passive: true });
    track.addEventListener('touchend', function (event) {
      if (!touchStart || !event.changedTouches || !event.changedTouches.length) return;
      var touch = event.changedTouches[0];
      var deltaX = touch.clientX - touchStart.x;
      var deltaY = touch.clientY - touchStart.y;
      if (Math.abs(deltaX) >= 34 && Math.abs(deltaX) > Math.abs(deltaY) * 1.15) {
        var target = Math.max(0, Math.min(slides.length - 1, touchStart.index + (deltaX < 0 ? 1 : -1)));
        track.scrollTo({ left: target * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
        syncSlide(target);
        swipe.dataset.swipeBlockUntil = String(Date.now() + 500);
        event.preventDefault();
      }
      touchStart = null;
    }, { passive: false });
    track.addEventListener('touchcancel', function () { touchStart = null; }, { passive: true });
    if (card) {
      var cardLink = card.querySelector('[data-card-link]');
      if (cardLink) cardLink.addEventListener('click', function (event) {
        if (Date.now() < Number(swipe.dataset.swipeBlockUntil || 0)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
    }
    enableDrag(track);
  }
  window.EEInitCardSwipe = initCardSwipe;
  var initCardSwipes = function () {
    document.querySelectorAll('[data-cardswipe]').forEach(initCardSwipe);
  };
  if ('requestIdleCallback' in window) {
    requestIdleCallback(initCardSwipes, { timeout: 1200 });
  } else {
    setTimeout(initCardSwipes, 80);
  }
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-cardswipe]').forEach(initCardSwipe);
  });
  document.addEventListener('click', function (event) {
    var finish = event.target.closest('[data-card-finish]');
    if (!finish) return;
    var card = finish.closest('[data-product-card]');
    if (!card) return;
    var track = card.querySelector('[data-cardswipe-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].dataset.url === finish.dataset.url) {
        track.scrollTo({ left: i * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
        break;
      }
    }
  });

  (function () {
    var gallery = document.querySelector('[data-ee-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-ee-gallery-track]');
    var counter = gallery.querySelector('[data-ee-gallery-count]');
    var prev = gallery.querySelector('[data-ee-gallery-prev]');
    var next = gallery.querySelector('[data-ee-gallery-next]');
    if (!track) return;
    if (track.children.length < 2) return;
    function visibleSlides() {
      return Array.prototype.filter.call(track.children, function (s) { return !s.hidden; });
    }
    function setCounter(i) {
      var v = visibleSlides();
      if (counter) counter.textContent = (i + 1) + ' / ' + v.length;
      var current = v[i];
      document.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
        thumb.setAttribute('aria-current', current && thumb.dataset.flatIndex === current.dataset.flatIndex ? 'true' : 'false');
      });
    }
    function loadDeferred(scope) {
      if (!scope) return;
      scope.querySelectorAll('img[data-deferred-src]').forEach(function (image) {
        if (image.dataset.deferredPriority) image.fetchPriority = image.dataset.deferredPriority;
        image.src = image.dataset.deferredSrc;
        if (image.dataset.deferredSrcset) image.srcset = image.dataset.deferredSrcset;
        if (image.dataset.deferredSizes) image.sizes = image.dataset.deferredSizes;
        image.removeAttribute('data-deferred-src');
        image.removeAttribute('data-deferred-srcset');
        image.removeAttribute('data-deferred-sizes');
        image.removeAttribute('data-deferred-priority');
      });
    }
    function go(delta) {
      var w = track.clientWidth;
      var i = Math.round(track.scrollLeft / w) + delta;
      i = Math.max(0, Math.min(i, visibleSlides().length - 1));
      track.scrollTo({ left: i * w, behavior: reduced ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    watchSnap(track, setCounter);
    enableDrag(track);
    setCounter(0);
    document.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-product-thumb]');
      if (!thumb) return;
      var v = visibleSlides();
      for (var i = 0; i < v.length; i++) {
        if (v[i].dataset.flatIndex === thumb.dataset.flatIndex) {
          track.scrollTo({ left: i * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
          setCounter(i);
          break;
        }
      }
    });
    document.addEventListener('change', function (event) {
      var selector = event.target.closest('[data-variant-selector]');
      if (!selector || selector.dataset.variantGroup === undefined) return;
      var group = selector.dataset.variantGroup;
      var any = false;
      Array.prototype.forEach.call(track.children, function (slide) {
        var show = slide.dataset.mediaGroup === group;
        slide.hidden = !show;
        if (show) {
          any = true;
          loadDeferred(slide);
        }
      });
      document.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
        var show = thumb.dataset.mediaGroup === group;
        thumb.hidden = !show;
        if (show) loadDeferred(thumb);
      });
      if (!any) {
        Array.prototype.forEach.call(track.children, function (slide) { slide.hidden = false; });
      }
      track.scrollTo({ left: 0 });
      setCounter(0);
    });
  })();

  /* v5: custom cursor */
  if (finePointer && !reduced) {
    document.body.classList.add('ee-cursor-on');
    var cDot = document.createElement('div');
    cDot.className = 'ee-cursor-dot';
    var cRing = document.createElement('div');
    cRing.className = 'ee-cursor-ring';
    var cLabel = document.createElement('span');
    cRing.appendChild(cLabel);
    document.body.appendChild(cDot);
    document.body.appendChild(cRing);
    var mx = -100, my = -100, rx = -100, ry = -100, cursorFrame = 0;
    function cursorPaint() {
      rx += (mx - rx) * 0.22;
      ry += (my - ry) * 0.22;
      cRing.style.transform = 'translate3d(' + rx + 'px,' + ry + 'px,0) translate(-50%,-50%)';
      if (Math.abs(mx - rx) > 0.2 || Math.abs(my - ry) > 0.2) cursorFrame = requestAnimationFrame(cursorPaint);
      else cursorFrame = 0;
    }
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      cDot.style.transform = 'translate3d(' + mx + 'px,' + my + 'px,0) translate(-50%,-50%)';
      if (!cursorFrame) cursorFrame = requestAnimationFrame(cursorPaint);
    }, { passive: true });
    document.addEventListener('mouseover', function (e) {
      var drag = e.target.closest('[data-cardswipe-track],[data-carousel-track],[data-heroslider-track],[data-ee-gallery-track]');
      var card = e.target.closest('.product-card,.ee-carousel__slide');
      var link = e.target.closest('a,button,label');
      if (drag) { cRing.classList.add('is-label'); cLabel.textContent = 'Drag'; }
      else if (card) { cRing.classList.add('is-label'); cLabel.textContent = 'View'; }
      else { cRing.classList.remove('is-label'); cLabel.textContent = ''; }
      cRing.classList.toggle('is-link', !!link && !drag && !card);
    });
    document.addEventListener('mousedown', function () { cRing.classList.add('is-down'); });
    document.addEventListener('mouseup', function () { cRing.classList.remove('is-down'); });
    document.documentElement.addEventListener('mouseleave', function () { cDot.style.opacity = '0'; cRing.style.opacity = '0'; });
    document.documentElement.addEventListener('mouseenter', function () { cDot.style.opacity = '1'; cRing.style.opacity = '1'; });
  }

  /* v5: masked word reveals */
  if (!reduced) {
    var wordTargets = document.querySelectorAll('.section-title,.ee-heroslider__title,.ee-carousel__head h2,.ee-drop__title');
    var splitWords = function (el) {
      if (el.dataset.split === 'true' || el.children.length > 0) { el.classList.add('ee-words-in'); return; }
      el.dataset.split = 'true';
      var words = el.textContent.trim().split(/\s+/);
      el.textContent = '';
      words.forEach(function (w, i) {
        var mask = document.createElement('span');
        mask.className = 'ee-word';
        var inner = document.createElement('i');
        inner.textContent = w;
        inner.style.setProperty('--w', String(i));
        mask.appendChild(inner);
        el.appendChild(mask);
        el.appendChild(document.createTextNode(' '));
      });
      el.classList.add('ee-words-in');
    };
    var wordObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        splitWords(entry.target);
        wordObserver.unobserve(entry.target);
      });
    }, { rootMargin: '160px 0px', threshold: 0.01 }) : null;
    wordTargets.forEach(function (el) {
      if (wordObserver) { wordObserver.observe(el); } else { splitWords(el); }
    });
  }

  /* v5: hero image parallax */
  if (!reduced) {
    var heroSection = document.querySelector('.ee-heroslider');
    if (heroSection) {
      var heroTicking = false;
      var heroPaint = function () {
        var rect = heroSection.getBoundingClientRect();
        var progress = Math.max(-1, Math.min(1, rect.top / Math.max(window.innerHeight, 1)));
        var pos = 30 - progress * 12;
        heroSection.querySelectorAll('.ee-heroslider__img').forEach(function (img) {
          img.style.objectPosition = 'center ' + pos.toFixed(1) + '%';
        });
        heroTicking = false;
      };
      window.addEventListener('scroll', function () {
        if (!heroTicking) { requestAnimationFrame(heroPaint); heroTicking = true; }
      }, { passive: true });
      heroPaint();
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-pdp-parity"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const h1 = document.querySelector('.ee-product-page h1');
  if (!h1 || h1.dataset.eeppSplit) return;

  const text = h1.textContent.replace(/\s+/g, ' ').trim();
  if (!text) return;
  h1.dataset.eeppSplit = '1';

  /* Screen readers keep the whole title; the split spans are decorative. */
  h1.setAttribute('aria-label', text);
  const frag = document.createDocumentFragment();
  text.split(' ').forEach((word, i) => {
    const outer = document.createElement('span');
    outer.className = 'eepp-split';
    outer.setAttribute('aria-hidden', 'true');
    const inner = document.createElement('span');
    inner.style.setProperty('--eepp-d', (i * 40) + 'ms');
    inner.textContent = word;
    outer.appendChild(inner);
    frag.appendChild(outer);
    if (i < text.split(' ').length - 1) frag.appendChild(document.createTextNode(' '));
  });
  h1.textContent = '';
  h1.appendChild(frag);

  const light = () => h1.classList.add('eepp-lit');
  if (RM || !('IntersectionObserver' in window)) { light(); return; }
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { light(); io.disconnect(); }
  }), { threshold: .15 });
  io.observe(h1);
  /* failsafe: never leave the title invisible */
  setTimeout(light, 2500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-shop-look"] && !Shopify.designMode) return;
  try {
    
(function(){
var RM=function(){return window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;};
function init(root){
  if(root.dataset.eeslReady)return;root.dataset.eeslReady='1';
  var track=root.querySelector('[data-eesl-track]');if(!track)return;
  var cards=[].slice.call(track.querySelectorAll('[data-eesl-card]'));if(!cards.length)return;
  var dots=[].slice.call(root.querySelectorAll('[data-eesl-go]'));
  var steps=[].slice.call(root.querySelectorAll('[data-eesl-step]'));
  var status=root.querySelector('[data-eesl-status]');
  var shop=root.querySelector('[data-eesl-shop]');
  var current=-1,frame=0;
  var centerOf=function(c){return c.offsetLeft+c.offsetWidth/2;};

  function paint(){
    frame=0;
    var w=track.clientWidth||1,c=track.scrollLeft+w/2,flat=RM(),best=0,bd=Infinity;
    for(var i=0;i<cards.length;i++){
      var s=cards[i],d=(centerOf(s)-c)/w,a=Math.abs(d);
      if(a<bd){bd=a;best=i;}
      if(flat){s.classList.add('is-flat');continue;}
      s.classList.remove('is-flat');
      var k=Math.max(-1.7,Math.min(1.7,d)),ak=Math.abs(k);
      s.style.setProperty('--ry',(k*-32).toFixed(2)+'deg');
      s.style.setProperty('--tz',(ak*-260).toFixed(1)+'px');
      s.style.setProperty('--sc',(1-ak*0.17).toFixed(3));
      s.style.setProperty('--op',Math.max(.2,1-ak*0.75).toFixed(3));
    }
    if(best!==current){
      current=best;
      cards.forEach(function(s,i){
        s.classList.toggle('is-active',i===current);
        s.querySelectorAll('a').forEach(function(el){
          if(i===current){el.removeAttribute('tabindex');}else{el.setAttribute('tabindex','-1');}
        });
      });
      dots.forEach(function(d,i){d.setAttribute('aria-pressed',String(i===current));});
      steps.forEach(function(b){b.disabled=Number(b.dataset.eeslStep)<0?current===0:current===cards.length-1;});
      var card=cards[current];
      if(status)status.textContent=card.dataset.eeslName||'';
      if(shop){
        shop.href=card.dataset.eeslUrl||shop.href;
        if(card.dataset.eeslCta)shop.textContent=card.dataset.eeslCta;
        shop.setAttribute('aria-label',(card.dataset.eeslCta||'Shop now')+' — '+(card.dataset.eeslName||''));
      }
    }
  }
  function schedule(){if(!frame)frame=requestAnimationFrame(paint);}
  function go(i){
    i=Math.max(0,Math.min(cards.length-1,i));
    track.scrollTo({left:centerOf(cards[i])-track.clientWidth/2,behavior:RM()?'auto':'smooth'});
  }

  var delay=Number(root.dataset.autoplay||0),timer=0,paused=false;
  function tick(){ if(paused||RM()||document.hidden)return; go(current>=cards.length-1?0:current+1); }
  function play(){ if(!delay||RM())return; clearInterval(timer); timer=setInterval(tick,delay); }
  function hold(){ paused=true; }
  function release(){ paused=false; play(); }
  function nudge(){ paused=true; clearInterval(timer); setTimeout(function(){paused=false;play();},delay||4000); }
  if(delay&&!RM()){
    root.addEventListener('pointerenter',hold);
    root.addEventListener('pointerleave',release);
    root.addEventListener('focusin',hold);
    root.addEventListener('focusout',release);
    document.addEventListener('visibilitychange',function(){ if(document.hidden){hold();}else{release();} });
    play();
  }

  var dragging=false,startX=0,startScroll=0,moved=false;
  track.addEventListener('pointerdown',function(e){
    if(e.pointerType!=='mouse'||e.button!==0)return;
    dragging=true;moved=false;startX=e.clientX;startScroll=track.scrollLeft;
    track.classList.add('is-grabbing');
    try{track.setPointerCapture(e.pointerId);}catch(err){}
    hold();
  });
  track.addEventListener('pointermove',function(e){
    if(!dragging)return;
    var dx=e.clientX-startX;
    if(Math.abs(dx)>3)moved=true;
    track.scrollLeft=startScroll-dx;
  });
  function endDrag(e){
    if(!dragging)return;
    dragging=false;
    track.classList.remove('is-grabbing');
    try{track.releasePointerCapture(e.pointerId);}catch(err){}
    var w=track.clientWidth||1,c=track.scrollLeft+w/2,best=0,bd=Infinity;
    cards.forEach(function(s,i){var a=Math.abs(centerOf(s)-c);if(a<bd){bd=a;best=i;}});
    go(best);
    nudge();
  }
  track.addEventListener('pointerup',endDrag);
  track.addEventListener('pointercancel',endDrag);
  track.addEventListener('click',function(e){ if(moved){e.preventDefault();e.stopPropagation();moved=false;} },true);

  root.addEventListener('click',function(e){
    var dot=e.target.closest('[data-eesl-go]');
    if(dot){go(Number(dot.dataset.eeslGo));nudge();return;}
    var step=e.target.closest('[data-eesl-step]');
    if(step){go(current+Number(step.dataset.eeslStep));nudge();}
  });
  track.addEventListener('keydown',function(e){
    if(e.target!==track)return;
    if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(current+(e.key==='ArrowRight'?1:-1));nudge();}
  });
  track.addEventListener('scroll',schedule,{passive:true});
  track.addEventListener('wheel',nudge,{passive:true});
  if('ResizeObserver' in window){new ResizeObserver(function(){var s=cards[Math.max(0,current)];if(s)track.scrollLeft=centerOf(s)-track.clientWidth/2;schedule();}).observe(track);}
  schedule();

  var fades=[].slice.call(root.querySelectorAll('[data-eesl-fade]'));
  if(RM()||!('IntersectionObserver' in window)){fades.forEach(function(f){f.classList.add('is-in');});}
  else{
    var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);}});},{threshold:.08});
    fades.forEach(function(f){io.observe(f);});
    setTimeout(function(){fades.forEach(function(f){var r=f.getBoundingClientRect();if(r.top<(window.innerHeight||0))f.classList.add('is-in');});},2500);
  }
}
function boot(scope){(scope||document).querySelectorAll('[data-eesl]').forEach(init);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot(document);});else boot(document);
document.addEventListener('shopify:section:load',function(e){boot(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-studio-fit"]) return;
  try {
    
document.querySelectorAll('[data-fit-page]').forEach(root=>{const form=root.querySelector('[data-fit-compare]'),result=root.querySelector('[data-fit-result]');const intro=()=>{result.innerHTML='<p>Enter all three measurements to see your comparison.</p>';};form.addEventListener('submit',event=>{event.preventDefault();if(!form.reportValidity())return;const current=['lens','bridge','temple'].map(name=>Number(form.elements[name].value));if(current.some(x=>!Number.isInteger(x)||x<1||x>300))return;const selected=form.elements.model.selectedOptions[0],sizes=selected.dataset.size.split(',').map(Number),labels=['Lens width','Bridge','Temple length'];result.replaceChildren();const title=document.createElement('p');title.textContent='Model '+selected.value+' compared with your current frame';result.append(title);const grid=document.createElement('div');grid.className='ee-fit-results';sizes.forEach((size,i)=>{const cell=document.createElement('span'),strong=document.createElement('strong'),difference=size-current[i];cell.append(labels[i]);strong.textContent=difference===0?'Same':(difference>0?'+':'−')+Math.abs(difference)+' mm';cell.append(strong);grid.append(cell);});result.append(grid);const note=document.createElement('p');note.textContent='Positive numbers mean the listed dimension is larger; negative numbers mean it is smaller. Similar measurements do not guarantee the same fit.';result.append(note);const link=document.createElement('a');link.href=selected.dataset.url;link.className='ee-text-link';link.textContent='View Model '+selected.value+' ↗';result.append(link);});form.addEventListener('reset',intro);form.addEventListener('input',intro);form.elements.model.addEventListener('change',intro);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-studio-home"] && !Shopify.designMode) return;
  try {
    
(()=>{
const mm=q=>window.matchMedia?window.matchMedia(q):{matches:false};
const RM=()=>mm('(prefers-reduced-motion: reduce)').matches;
const FINE=()=>mm('(hover: hover) and (pointer: fine)').matches;

const reveal=root=>{
  const items=[...root.querySelectorAll('[data-ee-reveal]')];
  if(!items.length)return;
  if(RM()||!('IntersectionObserver' in window)){items.forEach(el=>el.classList.add('is-in'));return;}
  const io=new IntersectionObserver(es=>es.forEach(en=>{if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);}}),{rootMargin:'0px 0px -8% 0px',threshold:.08});
  items.forEach(el=>io.observe(el));
};

const coverflow=root=>{
  const track=root.querySelector('[data-colour-track]');
  if(!track)return;
  const slides=[...track.querySelectorAll('[data-colour-slide]')];
  if(!slides.length)return;
  const dots=[...root.querySelectorAll('[data-colour-index]')];
  const steps=[...root.querySelectorAll('[data-colour-step]')];
  const status=root.querySelector('[data-colour-status]');
  let current=-1,frame=0;
  const centerOf=s=>s.offsetLeft+s.offsetWidth/2;
  const paint=()=>{
    frame=0;
    const w=track.clientWidth||1,c=track.scrollLeft+w/2,flat=RM();
    let best=0,bd=Infinity;
    slides.forEach((s,i)=>{
      const d=(centerOf(s)-c)/w,a=Math.abs(d);
      if(a<bd){bd=a;best=i;}
      if(flat){s.classList.add('is-flat');return;}
      s.classList.remove('is-flat');
      const k=Math.max(-1.5,Math.min(1.5,d)),ak=Math.abs(k);
      s.style.setProperty('--ry',(k*-28).toFixed(2)+'deg');
      s.style.setProperty('--tz',(ak*-210).toFixed(1)+'px');
      s.style.setProperty('--sc',(1-ak*0.14).toFixed(3));
      s.style.setProperty('--op',Math.max(.25,1-ak*0.7).toFixed(3));
    });
    if(best!==current){
      current=best;
      slides.forEach((s,i)=>s.classList.toggle('is-active',i===current));
      dots.forEach((d,i)=>d.setAttribute('aria-pressed',String(i===current)));
      steps.forEach(b=>{b.disabled=Number(b.dataset.colourStep)<0?current===0:current===slides.length-1;});
      if(status)status.textContent=slides[current].dataset.colourName||'';
    }
  };
  const schedule=()=>{if(!frame)frame=requestAnimationFrame(paint);};
  const go=i=>{
    i=Math.max(0,Math.min(slides.length-1,i));
    const s=slides[i];
    track.scrollTo({left:centerOf(s)-track.clientWidth/2,behavior:RM()?'auto':'smooth'});
  };
  root.addEventListener('click',e=>{
    const dot=e.target.closest('[data-colour-index]');
    if(dot){go(Number(dot.dataset.colourIndex));return;}
    const step=e.target.closest('[data-colour-step]');
    if(step){go(current+Number(step.dataset.colourStep));return;}
    const angle=e.target.closest('[data-angle-src]');
    if(!angle)return;
    const slide=angle.closest('[data-colour-slide]');
    const img=slide&&slide.querySelector('.eeh-angle-image');
    if(!img)return;
    slide.querySelectorAll('[data-angle-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===angle)));
    const swap=()=>{img.removeAttribute('srcset');img.src=angle.dataset.angleSrc;img.alt=angle.dataset.angleAlt;};
    if(RM()){swap();return;}
    img.classList.add('is-swapping');
    setTimeout(()=>{swap();requestAnimationFrame(()=>img.classList.remove('is-swapping'));},170);
  });
  track.addEventListener('keydown',e=>{
    if(e.target!==track)return;
    if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(current+(e.key==='ArrowRight'?1:-1));}
  });
  track.addEventListener('scroll',schedule,{passive:true});
  if('ResizeObserver' in window){
    new ResizeObserver(()=>{const s=slides[Math.max(0,current)];if(s)track.scrollLeft=centerOf(s)-track.clientWidth/2;schedule();}).observe(track);
  }
  schedule();
};

const parallax=root=>{
  if(RM())return;
  const targets=[];
  const hero=root.querySelector('.eeh-hero-media picture');
  if(hero)targets.push({el:hero,prop:'--py',amt:-38});
  const det=root.querySelector('.eeh-detail-picture img');
  if(det)targets.push({el:det,prop:'--px',amt:-30});
  if(!targets.length)return;
  let frame=0;
  const run=()=>{
    frame=0;
    const vh=window.innerHeight||1;
    targets.forEach(t=>{
      const r=t.el.getBoundingClientRect();
      if(r.bottom<-150||r.top>vh+150)return;
      const p=(r.top+r.height/2-vh/2)/vh;
      t.el.style.setProperty(t.prop,(p*t.amt).toFixed(1)+'px');
    });
  };
  const on=()=>{if(!frame)frame=requestAnimationFrame(run);};
  window.addEventListener('scroll',on,{passive:true});
  window.addEventListener('resize',on,{passive:true});
  run();
};

const counters=root=>{
  const cells=[...root.querySelectorAll('[data-ee-count]')];
  if(!cells.length||RM()||!('IntersectionObserver' in window))return;
  const io=new IntersectionObserver(es=>es.forEach(en=>{
    if(!en.isIntersecting)return;
    io.unobserve(en.target);
    const el=en.target,end=parseInt(el.textContent,10);
    if(!Number.isFinite(end))return;
    const t0=performance.now(),dur=850;
    const tick=t=>{const k=Math.min(1,(t-t0)/dur),e=1-Math.pow(1-k,3);el.textContent=String(Math.round(end*e));if(k<1)requestAnimationFrame(tick);else el.textContent=String(end);};
    requestAnimationFrame(tick);
  }),{threshold:.6});
  cells.forEach(c=>io.observe(c));
};

const tilt=root=>{
  if(RM()||!FINE())return;
  root.querySelectorAll('[data-ee-tilt]').forEach(card=>{
    let frame=0,rx=0,ry=0,on=false;
    const apply=()=>{frame=0;card.style.transform=on?'perspective(900px) rotateX('+rx.toFixed(2)+'deg) rotateY('+ry.toFixed(2)+'deg) translateZ(8px)':'';};
    const queue=()=>{if(!frame)frame=requestAnimationFrame(apply);};
    card.addEventListener('pointermove',e=>{
      if(e.pointerType!=='mouse')return;
      const r=card.getBoundingClientRect();
      ry=((e.clientX-r.left)/r.width-.5)*9;
      rx=(.5-(e.clientY-r.top)/r.height)*7;
      on=true;queue();
    });
    card.addEventListener('pointerleave',()=>{on=false;rx=ry=0;queue();});
  });
};

const init=root=>{
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  reveal(root);coverflow(root);parallax(root);counters(root);tilt(root);
};
document.querySelectorAll('[data-ee-home]').forEach(init);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-ee-home]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-studio-product"]) return;
  try {
    
(()=>{const init=scope=>scope.querySelectorAll('[data-ee-purchase][data-has-variants]').forEach(info=>{if(info.dataset.ready)return;info.dataset.ready='true';const select=info.querySelector('[data-photo-select]'),swatches=info.querySelector('[data-photo-swatches]');if(!select||!swatches)return;select.hidden=true;const fallback=info.querySelector('[data-variant-fallback]');if(fallback)fallback.hidden=true;swatches.hidden=false;const sync=()=>{const label=info.querySelector('[data-selected-colour]');if(label)label.textContent=select.selectedOptions[0].textContent.replace(/ · .*$/,'').trim();info.querySelectorAll('[data-photo-variant]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.photoVariant===select.value)));const status=info.querySelector('[data-stock-status]');if(status){const ok=select.selectedOptions[0].dataset.available==='true';status.textContent=ok?(status.dataset.okLabel||status.textContent):(info.querySelector('[data-add]')?.dataset.soldLabel||status.textContent);}};info.addEventListener('click',event=>{const button=event.target.closest('[data-photo-variant]');if(!button)return;select.value=button.dataset.photoVariant;select.dispatchEvent(new Event('change',{bubbles:true}));sync();});select.addEventListener('change',sync);const status=info.querySelector('[data-stock-status]');if(status)status.dataset.okLabel=status.textContent;sync();});if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);document.addEventListener('shopify:section:load',event=>init(event.target));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infrared-global"]) return;
  try {
    
  document.documentElement.classList.remove('no-js');
  document.addEventListener('click', function(event) {
    var cardFinish = event.target.closest('[data-card-finish]');
    if (cardFinish) {
      var card = cardFinish.closest('[data-product-card]');
      if (!card) return;
      var cardImage = card.querySelector('[data-card-image], .product-card__image img');
      var cardLink = card.querySelector('[data-card-link]');
      var cardLabel = card.querySelector('[data-card-finish-label]');
      var cardPrice = card.querySelector('[data-card-price]');
      if (cardImage && cardFinish.dataset.image) {
        cardImage.src = cardFinish.dataset.image;
        cardImage.srcset = '';
        cardImage.alt = cardFinish.dataset.alt || cardImage.alt;
      }
      if (cardLink && cardFinish.dataset.url) cardLink.href = cardFinish.dataset.url;
      if (cardLabel) cardLabel.textContent = cardFinish.dataset.title || cardFinish.title;
      if (cardPrice && cardFinish.dataset.price) cardPrice.textContent = cardFinish.dataset.price;
      card.querySelectorAll('[data-card-finish]').forEach(function(option) { option.setAttribute('aria-pressed', 'false'); });
      cardFinish.setAttribute('aria-pressed', 'true');
      return;
    }
    var thumb = event.target.closest('[data-product-thumb]');
    if (!thumb) return;
    var main = document.querySelector('[data-product-main-image]');
    if (!main) return;
    main.src = thumb.dataset.image;
    main.srcset = '';
    if (thumb.dataset.alt) main.alt = thumb.dataset.alt;
    document.querySelectorAll('[data-product-thumb]').forEach(function(item) { item.setAttribute('aria-current', 'false'); });
    thumb.setAttribute('aria-current', 'true');
  });
  var finishSwipeTimers = new WeakMap();
  function selectNearestFinish(rail) {
    if (!window.matchMedia('(max-width: 740px)').matches) return;
    var options = Array.prototype.slice.call(rail.querySelectorAll('[data-card-finish]'));
    if (!options.length) return;
    var railStyle = window.getComputedStyle(rail);
    var targetLeft = rail.getBoundingClientRect().left + (parseFloat(railStyle.paddingLeft) || 0);
    var nearest = options.reduce(function(best, option) {
      var distance = Math.abs(option.getBoundingClientRect().left - targetLeft);
      return !best || distance < best.distance ? { option: option, distance: distance } : best;
    }, null);
    if (nearest && nearest.option.getAttribute('aria-pressed') !== 'true') nearest.option.click();
  }
  document.addEventListener('scroll', function(event) {
    var rail = event.target && event.target.matches && event.target.matches('.product-card__finishes') ? event.target : null;
    if (!rail || !window.matchMedia('(max-width: 740px)').matches) return;
    window.clearTimeout(finishSwipeTimers.get(rail));
    finishSwipeTimers.set(rail, window.setTimeout(function() { selectNearestFinish(rail); }, 120));
  }, { capture: true, passive: true });
  var finishSwipeStarts = new WeakMap();
  document.addEventListener('pointerdown', function(event) {
    var rail = event.target.closest && event.target.closest('.product-card__finishes');
    if (!rail || !window.matchMedia('(max-width: 740px)').matches) return;
    finishSwipeStarts.set(rail, { x: event.clientX, y: event.clientY, scrollLeft: rail.scrollLeft });
  }, { passive: true });
  document.addEventListener('pointerup', function(event) {
    var rail = event.target.closest && event.target.closest('.product-card__finishes');
    var start = rail && finishSwipeStarts.get(rail);
    if (!rail || !start || !window.matchMedia('(max-width: 740px)').matches) return;
    finishSwipeStarts.delete(rail);
    var deltaX = event.clientX - start.x;
    var deltaY = event.clientY - start.y;
    if (Math.abs(deltaX) < 28 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.15) return;
    rail.dataset.finishSwipeUntil = String(Date.now() + 450);
    if (Math.abs(rail.scrollLeft - start.scrollLeft) >= 12) return;
    var options = Array.prototype.slice.call(rail.querySelectorAll('[data-card-finish]'));
    var current = options.findIndex(function(option) { return option.getAttribute('aria-pressed') === 'true'; });
    var next = Math.max(0, Math.min(options.length - 1, current + (deltaX < 0 ? 1 : -1)));
    if (options[next] && next !== current) options[next].click();
  }, { passive: true });
  document.addEventListener('click', function(event) {
    var rail = event.target.closest && event.target.closest('.product-card__finishes');
    if (!rail || !event.isTrusted) return;
    if (Date.now() < Number(rail.dataset.finishSwipeUntil || 0)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('change', function(event) {
    var selector = event.target.closest('[data-variant-selector]');
    if (!selector) return;
    var option = selector.matches('select') ? selector.options[selector.selectedIndex] : selector;
    var price = document.querySelector('[data-product-price]');
    var button = document.querySelector('[data-add-button]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (button) {
      button.disabled = option.dataset.available !== 'true';
      button.querySelector('span').textContent = option.dataset.available === 'true' ? button.dataset.addLabel : button.dataset.soldLabel;
    }
    var main = document.querySelector('[data-product-main-image]');
    var firstThumb = null;
    if (option.dataset.variantGroup) {
      document.querySelectorAll('[data-product-thumb]').forEach(function(item) {
        var isCurrentGroup = item.dataset.mediaGroup === option.dataset.variantGroup;
        item.hidden = !isCurrentGroup;
        item.setAttribute('aria-current', 'false');
        if (isCurrentGroup && !firstThumb) firstThumb = item;
      });
    }
    if (firstThumb) {
      firstThumb.setAttribute('aria-current', 'true');
      if (main) {
        main.src = firstThumb.dataset.image;
        main.srcset = '';
        if (firstThumb.dataset.alt) main.alt = firstThumb.dataset.alt;
      }
    } else if (option.dataset.image && main) {
      main.src = option.dataset.image;
      main.srcset = '';
      if (option.dataset.alt) main.alt = option.dataset.alt;
    }
  });
  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var motionObserver = null;
  function initializeMotion(root) {
    if (motionQuery.matches) return;
    document.documentElement.classList.add('motion-ready');
    var scope = root || document;
    var elements = scope.querySelectorAll('.hero-copy > *, .hero-stage, .series-head, .series-item, .featured-head, .product-card, .collection-hero > *, .product-gallery, .product-panel > *, .about-title > *, .about-body > *, .page-shell__grid > *, .footer-grid > *');
    if (!('IntersectionObserver' in window)) {
      elements.forEach(function(element) { element.classList.add('ee-reveal', 'is-visible'); });
      return;
    }
    if (!motionObserver) {
      motionObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          motionObserver.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    elements.forEach(function(element, index) {
      if (element.dataset.motionBound === 'true') return;
      element.dataset.motionBound = 'true';
      element.classList.add('ee-reveal');
      element.style.setProperty('--reveal-order', String(index % 5));
      motionObserver.observe(element);
    });
  }
  initializeMotion(document);
  document.addEventListener('shopify:section:load', function(event) { initializeMotion(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infrared-header"]) return;
  try {
    
  (function(){
    var header=document.querySelector('.site-header'),menu=document.querySelector('[data-ee-menu]'),menuOpen=document.querySelector('[data-ee-menu-open]'),menuClose=document.querySelector('[data-ee-menu-close]'),cart=document.querySelector('[data-ee-cart]'),cartOpen=document.querySelector('[data-ee-cart-open]'),cartClose=document.querySelector('[data-ee-cart-close]'),cartBody=cart&&cart.querySelector('[data-ee-cart-body]'),cartCount=cart&&cart.querySelector('[data-ee-cart-count]'),cartTotal=cart&&cart.querySelector('[data-ee-cart-total]'),cartFoot=cart&&cart.querySelector('[data-ee-cart-foot]'),dim=document.querySelector('[data-ee-dim]'),scrollTick=false;
    var money=new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0});
    function esc(value){var node=document.createElement('div');node.textContent=value==null?'':String(value);return node.innerHTML}
    function cartImage(src){if(!src)return '';return src+(src.indexOf('?')>-1?'&':'?')+'width=360'}
    function renderCart(state){
      if(!state||!cartBody)return;
      if(cartCount)cartCount.textContent=state.item_count;
      document.querySelectorAll('.ee-nav__count').forEach(function(node){node.textContent='('+state.item_count+')'});
      if(cartTotal)cartTotal.textContent=money.format(state.total_price/100);
      if(cartFoot)cartFoot.hidden=state.item_count===0;
      if(!state.items.length){cartBody.innerHTML='<div class="ee-cart-drawer__empty"><div><span class="ee-index">00</span><strong>Your cart is empty</strong><p>Start with a frame that fits your point of view.</p><a href="/collections/all">Explore eyewear ↗</a></div></div>';return}
      cartBody.innerHTML=state.items.map(function(item,index){var image=item.featured_image&&item.featured_image.url?item.featured_image.url:item.image;var variant=item.variant_title&&item.variant_title!=='Default Title'?'<p class="ee-micro">'+esc(item.variant_title)+'</p>':'';var properties=Object.keys(item.properties||{}).filter(function(key){return key.charAt(0)!=='_'&&item.properties[key]}).map(function(key){var value=String(item.properties[key]);return '<p class="ee-micro">'+esc(key)+': '+(value.indexOf('/uploads/')>-1?'File attached ✓':esc(value))+'</p>'}).join('');return '<article class="ee-cart-item"><a class="ee-cart-item__image" href="'+esc(item.url||item.product_url)+'">'+(image?'<img src="'+esc(cartImage(image))+'" alt="'+esc(item.product_title)+'" loading="lazy">':'')+'</a><div class="ee-cart-item__meta"><div><h3><a href="'+esc(item.url||item.product_url)+'">'+esc(item.product_title)+'</a></h3>'+variant+properties+'</div><div class="ee-cart-item__bottom"><span class="ee-cart-item__qty"><button type="button" data-ee-cart-change data-line="'+(index+1)+'" data-quantity="'+Math.max(0,item.quantity-1)+'" aria-label="Decrease quantity">−</button><span>'+item.quantity+'</span><button type="button" data-ee-cart-change data-line="'+(index+1)+'" data-quantity="'+(item.quantity+1)+'" aria-label="Increase quantity">+</button></span><div><strong class="ee-micro">'+money.format(item.final_line_price/100)+'</strong><button class="ee-cart-item__remove" type="button" data-ee-cart-change data-line="'+(index+1)+'" data-quantity="0">Remove</button></div></div></div></article>'}).join('')
    }
    function refreshCart(){return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(response){return response.json()}).then(function(state){renderCart(state);return state})}
    function syncHeader(){if(header)header.classList.toggle('is-scrolled',window.scrollY>12);scrollTick=false}
    function onScroll(){if(scrollTick)return;scrollTick=true;requestAnimationFrame(syncHeader)}
    function lock(){document.body.classList.add('ee-nav-locked')}function unlock(){document.body.classList.remove('ee-nav-locked')}
    function openMenu(){if(!menu)return;menu.classList.add('is-open');menu.setAttribute('aria-hidden','false');menuOpen.setAttribute('aria-expanded','true');lock();setTimeout(function(){menuClose.focus()},120)}
    function closeMenu(){if(!menu)return;menu.classList.remove('is-open');menu.setAttribute('aria-hidden','true');menuOpen.setAttribute('aria-expanded','false');unlock()}
    function openCart(){if(!cart)return;cart.classList.add('is-open');dim.classList.add('is-open');cart.setAttribute('aria-hidden','false');cartOpen.setAttribute('aria-expanded','true');lock();refreshCart();setTimeout(function(){cartClose.focus()},120)}
    function closeCart(){if(!cart)return;cart.classList.remove('is-open');dim.classList.remove('is-open');cart.setAttribute('aria-hidden','true');cartOpen.setAttribute('aria-expanded','false');unlock();if(cartOpen)cartOpen.focus()}
    syncHeader();window.addEventListener('scroll',onScroll,{passive:true});if(menuOpen)menuOpen.addEventListener('click',openMenu);if(menuClose)menuClose.addEventListener('click',closeMenu);if(cartOpen)cartOpen.addEventListener('click',openCart);if(cartClose)cartClose.addEventListener('click',closeCart);if(dim)dim.addEventListener('click',closeCart);if(cartBody)cartBody.addEventListener('click',function(event){var control=event.target.closest('[data-ee-cart-change]');if(!control)return;control.disabled=true;fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:Number(control.dataset.line),quantity:Number(control.dataset.quantity)})}).then(function(response){return response.json()}).then(renderCart)});document.addEventListener('ee:cart-updated',function(event){if(event.detail&&event.detail.cart)renderCart(event.detail.cart);openCart()});document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeMenu();closeCart()}});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function eeMoney(cents, currency) {
    var amount = (Number(cents) || 0) / 100;
    return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {style:'currency', currency:currency || 'INR', currencyDisplay:'narrowSymbol', minimumFractionDigits:amount % 1 ? 2 : 0, maximumFractionDigits:2}).format(amount);
  }
  function eeSyncTotal(root) {
    if (!root) return;
    var frame = Number(root.dataset.frameCents) || 0;
    var lens = Number(root.dataset.lensCents) || 0;
    var currency = root.dataset.currency || 'INR';
    var frameNode = root.querySelector('[data-total-frame]');
    var lensNode = root.querySelector('[data-total-lens]');
    var grandNode = root.querySelector('[data-total-grand]');
    var buyNode = root.querySelector('[data-buy-total]');
    if (frameNode) frameNode.textContent = eeMoney(frame, currency);
    if (lensNode) lensNode.textContent = eeMoney(lens, currency);
    if (grandNode) grandNode.textContent = eeMoney(frame + lens, currency);
    if (buyNode) buyNode.textContent = eeMoney(frame + lens, currency);
  }
  function eeSwapVariantImage(root, selector) {
    if (!root || !selector || !selector.dataset.image) return;
    var image = root.querySelector('.ee-gallery__active-image');
    var finish = root.querySelector('[data-gallery-finish]');
    if (finish && selector.dataset.title) finish.textContent = selector.dataset.title;
    if (!image || image.currentSrc === selector.dataset.image || image.src === selector.dataset.image) return;
    var requestId = selector.value;
    root.dataset.galleryRequest = requestId;
    image.classList.add('is-changing');
    var preload = new Image();
    preload.decoding = 'async';
    preload.sizes = '(min-width: 1100px) 58vw, 100vw';
    if (selector.dataset.imageSrcset) preload.srcset = selector.dataset.imageSrcset;
    preload.src = selector.dataset.image;
    var commit = function () {
      if (root.dataset.galleryRequest !== requestId) return;
      image.src = selector.dataset.image;
      if (selector.dataset.imageSrcset) image.srcset = selector.dataset.imageSrcset;
      image.alt = selector.dataset.alt || selector.dataset.title || '';
      requestAnimationFrame(function () { image.classList.remove('is-changing'); });
    };
    if (preload.decode) {
      preload.decode().then(commit).catch(commit);
    } else {
      preload.onload = commit;
      preload.onerror = commit;
    }
  }
  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.parentElement.querySelector('input[name="quantity"]');
    if (!input) return;
    var next = (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qtyStep, 10);
    input.value = Math.max(1, next);
  });
  document.addEventListener('change', function (event) {
    var selector = event.target.closest('[data-variant-selector]');
    if (selector) {
      var commerce = selector.closest('[data-product-commerce]');
      var label = commerce && commerce.querySelector('[data-selected-finish]');
      if (label && selector.dataset.title) label.textContent = selector.dataset.title;
      var price = commerce && commerce.querySelector('[data-product-price]');
      var compare = commerce && commerce.querySelector('[data-product-compare]');
      var stock = commerce && commerce.querySelector('[data-product-stock]');
      if (price) price.textContent = selector.dataset.price || price.textContent;
      if (compare) {
        compare.textContent = selector.dataset.comparePrice || '';
        compare.hidden = !selector.dataset.comparePrice;
      }
      if (stock) {
        var available = selector.dataset.available === 'true';
        stock.textContent = available ? stock.dataset.availableLabel : stock.dataset.soldLabel;
        stock.classList.toggle('is-sold', !available);
      }
      if (commerce) {
        commerce.dataset.frameCents = selector.dataset.priceCents || '0';
        eeSyncTotal(commerce);
        eeSwapVariantImage(commerce, selector);
      }
    }
    var lens = event.target.closest('input[name="lens_variant"]');
    if (lens) {
      var lensCommerce = lens.closest('[data-product-commerce]');
      var prop = document.querySelector('[data-lens-property]');
      if (prop) prop.value = lens.dataset.label || 'Frame only (demo lenses)';
      if (lensCommerce) {
        lensCommerce.dataset.lensCents = lens.dataset.priceCents || '0';
        eeSyncTotal(lensCommerce);
      }
    }
  });
  document.querySelectorAll('[data-product-commerce]').forEach(eeSyncTotal);

  } catch(e) { console.error(e); }
})();
})();
